module.exports = __webpack_public_path__ + "static/media/walking.a1385d6a.svg";